<script>
  import api from "$/client/api.js";
  import { base_host } from "$/client/config.js";
  export let product_id;
  export let price;
  export let preorder;
  export let active;
  let error = undefined;

  const add_to_cart = async () => {
    // have to use OG base host to make sure it points at the public URL
    const [status, data] = await api.post(`${base_host}/api/cart`, { product_id });
    if(status === 200) {
      // have to do it this way so it works in rendered pages Hydrated
      window.location = "/client/#/cart/";
    } else if(status === 500) {
      error = "Major server failure, please email help@learncodethehardway.com to report it.";
    } else {
      console.log("Error!", status, data);
    }
  }
</script>

{#if active}
  {#if error }
    <toast>{ error }</toast>
  {:else}
    <button type="button" data-testid="purchase-button" on:click={ add_to_cart }>
      {#if price == 0}
        Register for Free
      {:else if preorder}
        Pre-Order for ${ price } USD
      {:else}
        Purchase for ${ price } USD
      {/if}
    </button>
  {/if}
{/if}
